export default "__VITE_ASSET__4rFHfHhE__"